import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { MultiSelectOption } from '@klareospace/pharos-lib-web-utils';

export function useRoleOptions(): MultiSelectOption[] {
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('settings');

  return useMemo(
    () => [
      { label: tCommon('fields.carrierRoleLabel'), value: 'CARRIER' },
      { label: t('users.roles.DRIVER'), value: 'DRIVER' },
      { label: t('users.roles.SITE_MANAGER'), value: 'SITE_MANAGER' },
      { label: t('users.roles.SITE_OPERATOR'), value: 'SITE_OPERATOR' },
      { label: t('users.roles.SPACE_ADMIN'), value: 'SPACE_ADMIN' },
      { label: t('users.roles.TENANT_ADMIN'), value: 'TENANT_ADMIN' },
    ],
    [t],
  );
}
